import React, { useEffect, useState } from "react";
import { fetchUserLanguageDetails } from "../api";
import {
  Paper,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

const tableStyles = {
  borderRadius: 3,
  boxShadow: "0 2px 16px #E6E9F4",
  overflow: "hidden",
  background: "#fff",
};

const headCellStyles = {
  background: "#E3DDE8",
  color: "#353765",
  fontWeight: 700,
  fontSize: 17,
  borderBottom: "2px solid #F2F3F7",
  letterSpacing: 0.2,
  textAlign: "center",
};

const bodyCellStyles = {
  color: "#353765",
  fontWeight: 500,
  fontSize: 16,
  borderBottom: "1px solid #F2F3F7",
  padding: "18px 12px",
  background: "#fff",
  textAlign: "center",
};

const statsLabel = {
  color: "#8369AA",
  fontWeight: 700,
  fontSize: 14,
  mr: 1,
};

const statsValue = {
  color: "#1A1248",
  fontWeight: 500,
  fontSize: 15,
  ml: 0.5,
};

const LanguageGameplay = ({ userId, language }) => {
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setDetails(null);
    fetchUserLanguageDetails(userId, language).then((data) => {
      if (data.success) setDetails(data.userDetailsByLanguage);
      setLoading(false);
    });
  }, [userId, language]);

  if (loading)
    return (
      <Box
        sx={{ width: "100%", display: "flex", justifyContent: "center", py: 5 }}
      >
        <CircularProgress />
      </Box>
    );

  return (
    <Paper
      style={{
        padding: 12,
        borderRadius: 18,
        background: "#F6F2FC",
        boxShadow: "0 2px 12px #EFECF6",
        height: "calc(100vh - 350px)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography variant="h6" sx={{ color: "#6D32A6", fontWeight: 700 }}>
        {language.charAt(0).toUpperCase() + language.slice(1)} - Gameplay
        Details
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 5,
          background: "#EFE6FA",
          borderRadius: 3,
          px: 1,
          py: 1,
          mb: 1,
          mt: 1,
        }}
      >
        <Box>
          <span style={statsLabel}>Word Count:</span>
          <span style={statsValue}>{details.wordCount}</span>
        </Box>
        <Box>
          <span style={statsLabel}>Correct Attempts:</span>
          <span style={statsValue}>{details.correctAttemptCouter}</span>
        </Box>
        <Box>
          <span style={statsLabel}>Incorrect Attempts:</span>
          <span style={statsValue}>{details.incorrectAttemptCounter}</span>
        </Box>
        <Box>
          <span style={statsLabel}>Total Attempts:</span>
          <span style={statsValue}>{details.totalAttemptsCounter}</span>
        </Box>
      </Box>

      {/* Styled table */}
      <Paper
        elevation={0}
        sx={{
          ...tableStyles,
          flex: "1 1 auto",
          minHeight: 0,
          overflow: "auto",
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={headCellStyles}>Word</TableCell>
              <TableCell sx={headCellStyles}>Status</TableCell>
              <TableCell sx={headCellStyles}>Attempts</TableCell>
              <TableCell sx={headCellStyles}>Last Attempted</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {details.gameplayDetailsByLang.map((w) => (
              <TableRow
                key={w.wordId}
                sx={{
                  background: "#fff",
                  cursor: "pointer",
                  transition: "background 0.15s",
                  "&:hover td": { background: "#E3DDE8" },
                }}
              >
                <TableCell sx={bodyCellStyles}>{w.word}</TableCell>
                <TableCell
                  sx={{
                    ...bodyCellStyles,
                    color: w.status === "correct" ? "#20B26C" : "#E53E3E",
                    fontWeight: 700,
                    textTransform: "capitalize",
                  }}
                >
                  {w.status}
                </TableCell>
                <TableCell sx={bodyCellStyles}>{w.attempt_count}</TableCell>
                <TableCell sx={bodyCellStyles}>
                  {new Date(w.last_attempted_at).toLocaleString()}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Paper>
  );
};

export default LanguageGameplay;
